export default "__VITE_ASSET__DmQf9zky__"